import { Building2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function NoWorkspace() {
  const { user } = useAuth();
  return (
    <div
      data-testid="no-workspace"
      className="min-h-[60vh] flex items-center justify-center"
    >
      <div className="max-w-md text-center bg-white border border-[#EAE8E3] rounded-lg p-10">
        <div className="w-12 h-12 rounded-lg bg-[#5C8065]/12 mx-auto mb-4 flex items-center justify-center">
          <Building2 className="w-6 h-6 text-[#1F4E3D]" strokeWidth={1.5} />
        </div>
        <div className="label-overline mb-2">Almost there</div>
        <h2 className="font-display text-2xl tracking-tight font-medium mb-2">
          No workspace yet
        </h2>
        <p className="text-sm text-[#696E69] leading-relaxed">
          {user?.role === "admin"
            ? "Create a company from the Admin page to start tracking finances."
            : "An admin needs to assign you to a company. Ping them and you'll be good to go."}
        </p>
      </div>
    </div>
  );
}
